import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cli-landing-menu',
  templateUrl: './landing-menu.component.html',
  styleUrls: ['./landing-menu.component.scss']
})
export class LandingMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
